import type { Payment } from "../../domain/entities/Payment";
import type { PaymentTransaction } from "../../domain/entities/PaymentTransaction";
import type { PaymentProcessorPort } from "../ports/PaymentProcessorPort";

export class ProcessPaymentUseCase {
  constructor(private readonly paymentProcessorPort: PaymentProcessorPort) {}

  async execute(payment: Payment): Promise<PaymentTransaction> {
    return this.paymentProcessorPort.process(payment);
  }
}
